import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useInView } from '../../../hooks/useInView';

const AboutSection = () => {
  const { ref, isInView } = useInView({ threshold: 0.2 });

  const values = [
    {
      number: '01',
      title: '繋がり',
      subtitle: 'Connection',
      description: '人と人、想いと想いの間に立ち、縁を紡ぐ。',
    },
    {
      number: '02',
      title: '柔軟性',
      subtitle: 'Flexibility',
      description: '変化を恐れず、流れの中で新しい形を見つける。',
    },
    {
      number: '03',
      title: '誠実',
      subtitle: 'Integrity',
      description: '相手を思い、正直であることを軸に行動する。',
    },
    {
      number: '04',
      title: '調和',
      subtitle: 'Harmony',
      description: '多様な個が共に在り、ひとつの和を生み出す。',
    },
  ];

  return (
    <section ref={ref} className="relative bg-cream py-16 lg:py-24 overflow-hidden">
      {/* 装飾的な背景要素 */}
      <div className="absolute top-20 right-0 w-96 h-96 bg-sage opacity-10 rounded-full blur-3xl" />
      <div className="absolute bottom-20 left-0 w-80 h-80 bg-mustard opacity-10 rounded-full blur-3xl" />

      <div className="relative z-10 px-8 lg:px-16 max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="mb-6"
        >
          <span className="text-base tracking-wider text-warmgray font-sans">About</span>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="lg:col-span-12"
          >
            <h2 className="font-serif text-4xl lg:text-5xl text-darkgray leading-loose mb-6 font-light">
              共に歩み、共に未来の形を作る。<br />
              縁を結び、人で生きる。
            </h2>
            <p className="font-sans text-lg text-gray-600 leading-loose mb-10">
              SINAXは、技術を提供する会社ではなく、<br />
              課題に向き合い続けるパートナーでありたいと考えています。<br />
              現場や背景を理解しながら、状況に応じた判断と実行を重ね、<br />
              長く信頼される関係を築いていきます。
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
              {values.map((value, index) => (
                <motion.div
                  key={value.title}
                  initial={{ opacity: 0, y: 30 }}
                  animate={isInView ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.8, delay: 0.4 + index * 0.1 }}
                  className="relative bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow duration-300"
                >
                  <div className="absolute top-5 left-5 w-10 h-10 bg-sage bg-opacity-20 rounded-full flex items-center justify-center">
                    <span className="text-sage font-sans text-sm font-medium">{value.number}</span>
                  </div>
                  <div className="mt-14">
                    <h3 className="font-sans text-2xl text-darkgray mb-2 font-medium">
                      {value.title}
                    </h3>
                    <p className="text-sm text-sage mb-3 tracking-wide">{value.subtitle}</p>
                    <p className="font-sans text-base text-gray-600 leading-relaxed">
                      {value.description}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.8, delay: 0.8 }}
              className="flex justify-center"
            >
              <Link
                to="/company"
                className="inline-flex items-center gap-3 px-8 py-4 bg-darkgray text-white text-base font-sans tracking-wide rounded cursor-pointer transition-all duration-300 hover:bg-opacity-90 group"
              >
                会社情報を見る
                <i className="ri-arrow-right-line text-lg transition-transform duration-300 group-hover:translate-x-1"></i>
              </Link>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
